import { Box } from '@mui/material';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { TransactionStatusIcon } from '@/components/TransactionStatusIcon';
import { getTransactionStatusListForFilters } from '@/views/Interactions/helpers/InteractionStatus.helper';
import {
  getStatusFilterAtom,
  type InteractionTypeFilter,
  useToggleFilter,
} from '@/views/Interactions/state/filters';
import { FilterAutocomplete } from '../FilterAutocomplete';
import { FilterHeading } from '../FilterHeading';

interface Props {
  type: InteractionTypeFilter;
  stateKey: string;
}

export function TransactionStatusFilter({ type, stateKey }: Props) {
  const statuses = getTransactionStatusListForFilters(type);
  const statusAtom = getStatusFilterAtom(type);
  const [currentStatuses, setCurrentStatuses] = useAtom(statusAtom(stateKey));
  const toggleStatus = useToggleFilter(stateKey);
  const clearAllStatuses = useCallback(
    () => setCurrentStatuses([]),
    [setCurrentStatuses],
  );

  return (
    <Box>
      <FilterHeading
        icon={TransactionStatusIcon}
        iconSize="small"
        label="Transaction Status"
      />
      <FilterAutocomplete
        type={type}
        label="Transaction Status"
        hideLabel
        filterType="status"
        eventContainer="transaction_status_filter"
        placeholder="Select one or more"
        value={currentStatuses}
        options={statuses}
        onClear={clearAllStatuses}
        onToggle={toggleStatus}
      />
    </Box>
  );
}
